<!--
  name : 김혜진
  desc : 회원가입
  date : 2020-11-10
-->
<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" class="login_main_title">회원가입</v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center">
      <v-card id="popStyle02" class="popW800">
        <v-col cols="12">
          <v-tabs
            class="signup_M_tab"
            v-model="active"
            icons-and-text
            show-arrows="false"
          >
            <v-tab
              ><span class="signM_tab_tt">본인인증</span
              ><span class="signM_tab_tt_num">1단계</span></v-tab
            >
            <v-tab
              ><span class="signM_tab_tt">약관동의</span
              ><span class="signM_tab_tt_num">2단계</span></v-tab
            >
            <v-tab
              ><span class="signM_tab_tt">정보입력</span
              ><span class="signM_tab_tt_num">3단계</span></v-tab
            >
            <v-tab
              ><span class="signM_tab_tt">블록체인생성</span
              ><span class="signM_tab_tt_num">4단계</span></v-tab
            >
            <v-tab
              ><span class="signM_tab_tt">가입완료</span
              ><span class="signM_tab_tt_num">5단계</span></v-tab
            >
          </v-tabs>
        </v-col>
        <v-card-text class="signup-text">
          <v-row no-gutters>
            <v-tabs-items v-model="active" whidth="100%">
              <!--본인인증-->
              <v-tab-item>
                <certification
                  ref="certification"
                  @certEvent="certResult"
                ></certification>
              </v-tab-item>
              <!--/본인인증-->
              <!--약관동의 : 상세내용등 손봐야됨-->
              <v-tab-item>
                <acceptTerm
                  ref="acceptTerm"
                  :key="componentKey"
                  :parent-data="accountform"
                  @termEvent="termResult"
                ></acceptTerm>
              </v-tab-item>
              <!--/약관동의-->
              <!--정보입력-->
              <v-tab-item>
                <registerUser
                  ref="registerUser"
                  :key="componentKey"
                  :parent-data="accountform"
                  @regUserEvent="regUserResult"
                ></registerUser>
              </v-tab-item>
              <!--/정보입력-->
              <!--블록체인생성-->
              <v-tab-item>
                <createChainAddr
                  ref="createChainAddr"
                  :key="componentKey"
                  :parent-data="accountform"
                  @chainAddrEvent="chainAddrResult"
                ></createChainAddr>
              </v-tab-item>
              <!--/블록체인생성-->
              <!--가입완료-->
              <v-tab-item>
                <div v-if="isRegister === 0">
                  <div class="join_E_form">
                    글로싸인엔터프라이즈 회원 등록 중입니다.<br />잠시만
                    기다려주세요.
                  </div>
                </div>
                <div v-if="isRegister === 1">
                  <div class="join_E_form">
                    <span class="fc_p02"
                      >{{ UserInfo.userName }}({{ UserInfo.userEmail }})</span
                    >
                    고객님 글로싸인엔터프라이즈 가입이 완료되었습니다.<br />
                    <br />글로싸인엔터프라이즈는 개인 계약과 기업 계약을 모두
                    제공합니다.<br />
                    기업 담당자로 계약 하시려면 기업정보 설정을 완료해야
                    합니다.<br />
                    로그인 후 기업 설정에서 정보를 설정해 주세요.<br />
                  </div>
                  <v-card-actions class="justify-center signup_btnCon">
                    <v-btn
                      outlined
                      class="btn19_00 btnC_01 btn_bottom_W314"
                      @click="login"
                      >가입완료</v-btn
                    >
                    <!--login으로 이동-->
                  </v-card-actions>
                </div>
                <div v-if="isRegister === 2">
                  <div class="join_E_form">
                    죄송합니다.<br />알수없는 오류로 인하여 회원가입을 완료 할
                    수 없습니다.<br />
                    <br />다시 회원가입을 이용하시거나, <br />계속 동일한 문제가
                    발생 시 고객센터로 문의 부탁드립니다.
                  </div>
                  <v-card-actions class="justify-center signup_btnCon">
                    <v-btn
                      outlined
                      class="btn19_00 btnC_01 btn_bottom_W314"
                      @click="join"
                      >회원 가입</v-btn
                    >
                    <v-btn
                      outlined
                      class="btn19_00 btnC_01 btn_bottom_W314"
                      @click="main"
                      >메인화면 바로가기</v-btn
                    >
                    <!--login으로 이동-->
                  </v-card-actions>
                </div>
              </v-tab-item>
              <!--/가입완료-->
            </v-tabs-items>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
  </v-container>
</template>
<script>
import certification from "@/views/join/components/certification";
import acceptTerm from "@/views/join/components/acceptTerm";
import registerUser from "@/views/join/components/registerUser";
import createChainAddr from "@/views/join/components/createChainAddr";
import { createUser } from "@/api/join";

export default {
  name: "login",
  components: {
    certification,
    acceptTerm,
    registerUser,
    createChainAddr
  },
  filters: {},
  data() {
    return {
      componentKey: 0,
      active: null,
      // 사진 추가
      dialog00: false,
      // 사진 추가
      dialogImg: false,
      accountform: {
        auth_key: "",
        email: "",
        radio_trem_paivacy_op1: false,
        radio_trem_paivacy_op2: false,
        userid: "",
        password: "",
        password_re: "",
        name: "",
        addr_main: "",
        addr_sub: "",
        phone: ""
      },
      tempUserInfo: {
        userId: "",
        userPassword: "",
        userName: "",
        userAddress: "",
        chainAddress: "",
        userEmail: "",
        userCtr: "",
        authKey: "",
        authStatus: "",
        createDate: "",
        updateDate: ""
      },
      term_info: {
        TERM_CTR_MAIL: false,
        TERM_MAIL: false
      },
      UserInfo: {
        userId: "",
        userName: "",
        userAddress: "",
        chainAddress: "",
        userEmail: "",
        userCtr: ""
      },
      isRegister: 0
    };
  },
  created() {},
  mounted() {
    this.track();
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: "/join"
      });
    },
    certResult(accountform) {
      this.accountform = accountform;
      this.next(2);
    },
    termResult(accountform) {
      this.accountform = accountform;
      this.next(3);
    },
    regUserResult(accountform) {
      this.accountform = accountform;
      this.next(4);
    },
    chainAddrResult(sendData) {
      this.next(5);
      if (sendData.tempUserInfo === undefined) {
        this.isRegister = 2;
        this.invalid_info();
      } else {
        this.tempUserInfo = sendData.tempUserInfo;
        this.term_info.TERM_CTR_MAIL = this.accountform.radio_trem_paivacy_op1;
        this.term_info.TERM_MAIL = this.accountform.radio_trem_paivacy_op2;
        this.$nextTick(() => {
          this.initRegisterPersonalView();
        });
      }
    },
    invalid_info() {
      this.$refs.confirm
        .open(
          "confirm",
          "회원가입",
          "인증정보가 없습니다. 처음 단계부터 다시 시도해주세요."
        )
        .then(() => {
          this.$router.push({ name: "join" });
        });
    },
    initRegisterPersonalView() {
      this.$refs.loading.start("입력 정보 확인 중");

      this.$nextTick(() => {
        createUser(
          JSON.stringify({
            user: this.tempUserInfo,
            auth_key: this.tempUserInfo.authKey,
            term_info: this.term_info
          })
        ).then(Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.isRegister = 1;
            this.$refs.loading.end();
            this.UserInfo.userId = Response.rdata.user.userId;
            this.UserInfo.userName = Response.rdata.user.userName;
            this.UserInfo.userAddress = Response.rdata.user.userAddress;
            this.UserInfo.chainAddress = Response.rdata.user.chainAddress;
            this.UserInfo.userEmail = Response.rdata.user.userEmail;
            this.UserInfo.userCtr = Response.rdata.user.userCtr;
          } else {
            this.$refs.loading.end();
            var msg = "";
            if (Response.rdata === undefined) {
              msg = Response.message;
            } else {
              msg = Response.rdata.message;
            }
            this.$refs.confirm.open("confirm", "회원가입", msg).then(() => {
              this.$router.push({ name: "join" });
            });
          }
        });
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    join() {
      this.$router.push({ name: "join" });
    },
    main() {
      this.$router.push({ name: "main" });
    },
    next(page) {
      const active = parseInt(this.active);
      this.active = active < 5 ? active + 1 : 0;
      if (page === 2) {
        this.componentKey += 1;
      } else if (page === 3) {
        this.componentKey += 1;
      } else if (page === 4) {
        this.componentKey += 1;
      }
    }
  }
};
</script>
<style scoped></style>
